"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateChildSubsystem = void 0;
const options_1 = __importDefault(require("../../data/options"));
const utils_1 = require("../../utils");
const generate_assembly_devices_1 = require("./generate-assembly-devices");
const generateChildSubsystem = (contactRefId, subsystem, subsystemOptions) => {
    const name = (0, utils_1.shuffle)(options_1.default.childSubSystems);
    const assemblyDevices = (0, generate_assembly_devices_1.generateAssemblyDevices)(contactRefId, subsystem, name, subsystemOptions);
    const status = (0, utils_1.getMostSevereStatus)(assemblyDevices);
    return {
        name,
        status: status,
        subsystemParent: subsystem,
        assemblyDevices: assemblyDevices,
    };
};
exports.generateChildSubsystem = generateChildSubsystem;
